import { Injectable } from '@angular/core';
import { Action, State, StateContext } from '@ngxs/store';
import { Dossier } from '@sc/data-access-models';

import { FilterDossiersStates } from '../../models/dossiers-states';
import {
  SetDossiersSearchDossiersAction,
  SetFiltersSearchDossiersAction,
} from './search-dossiers.actions';

export const SearchDossiersStateKey: Readonly<string> = 'searchDossiers';
export const SearchDossiersStateDefault: Readonly<SearchDossiersStateObj> = {
  search: '',
  dossiers: [],
  dossiersStates: {
    inProgress: true,
    complete: true,
    cancelled: true,
    abandoned: true,
    requested: false,
    requestedAndValidated: false,
  },
};

export interface SearchDossiersStateObj {
  search: string;
  dossiers: Partial<Dossier>[];
  dossiersStates: FilterDossiersStates;
}

@State<SearchDossiersStateObj>({
  name: SearchDossiersStateKey,
  defaults: SearchDossiersStateDefault,
})
@Injectable()
export class SearchDossiersState {
  @Action(SetFiltersSearchDossiersAction)
  setFilters(
    ctx: StateContext<{ search: string; dossiersStates: FilterDossiersStates }>,
    { payload }: SetFiltersSearchDossiersAction
  ): void {
    const state = ctx.getState()
      ? ctx.getState()
      : ({} as SearchDossiersStateObj);

    ctx.setState({ ...state, ...payload });
  }

  @Action(SetDossiersSearchDossiersAction)
  setDossiers(
    ctx: StateContext<{ dossiers: Dossier[] }>,
    { payload }: SetDossiersSearchDossiersAction
  ): void {
    const state = ctx.getState()
      ? ctx.getState()
      : ({} as SearchDossiersStateObj);

    ctx.setState({ ...state, ...payload });
  }
}
